import ThemeOptions from './ThemeOptions';

const reducer = {
  ThemeOptions,
};

export default reducer;
